import React from 'react';
import type { FormRule } from 'antd';
import { Col, DatePicker, Form, InputNumber, Row } from 'antd';
import type { InvoiceStatusType } from 'api/swagger';
import { InvoiceStatus } from 'types/invoice-status';
import { FormCurrencySelect } from 'components/common/form-currency-select/form-currency-select';
import type { IInvoiceEditFormFields, IInvoiceEditFormProps } from 'components/invoices/invoice-edit-form/types';
import styles from './invoice-edit-form.module.scss';

const validationRule: Record<keyof IInvoiceEditFormFields, FormRule[]> = {
  price: [{ required: true, type: 'number', min: 0.01, message: 'Please enter a price greater than 0.01' }],
  currency: [{ required: true, type: 'string' }],
  vatPercent: [{ required: false, type: 'number', min: 0, max: 100 }],
  startPaymentPeriod: [{ required: false, type: 'date' }],
  endPaymentPeriod: [{ required: false, type: 'date' }],
  serviceDate: [{ required: false, type: 'date' }],
  issuedDate: [{ required: false, type: 'date' }],
};

export const InvoiceEditForm: React.FC<IInvoiceEditFormProps> = (props) => {
  const { form, formId, onFinish, initialValues, status } = props;

  const statusesWithPaymentPeriod: InvoiceStatusType[] = [
    InvoiceStatus.Waiting,
    InvoiceStatus.PartiallyPaid,
    InvoiceStatus.Problem,
    InvoiceStatus.Loss,
    InvoiceStatus.Completed,
  ];
  const shouldShowDatePickers = statusesWithPaymentPeriod.includes(status);

  return (
    <Form form={form} id={formId} layout='vertical' initialValues={initialValues} onFinish={onFinish}>
      <Form.Item label='Price' name='price' rules={validationRule.price}>
        <InputNumber
          placeholder='Price'
          type='number'
          className={styles.fullWidth}
          addonAfter={<FormCurrencySelect />}
        />
      </Form.Item>
      <Form.Item label='VAT' name='vatPercent' rules={validationRule.vatPercent}>
        <InputNumber placeholder='Vat' type={'number'} addonAfter='%' className={styles.fullWidth} />
      </Form.Item>
      {shouldShowDatePickers && (
        <>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label='Start Payment Period' name='startPaymentPeriod'>
                <DatePicker className={styles.fullWidth} allowClear={false} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label='End Payment Period' name='endPaymentPeriod'>
                <DatePicker className={styles.fullWidth} allowClear={false} />
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label='Service Date' name='serviceDate' rules={validationRule.serviceDate}>
            <DatePicker className={styles.fullWidth} allowClear={false} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label='Issued Date' name='issuedDate' rules={validationRule.issuedDate}>
            <DatePicker className={styles.fullWidth} allowClear={!initialValues.issuedDate} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
